import { useEffect, useState } from "react";
import api, { apiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";

const FIELDS = [
  { key: "company_name", label: "Nom de l'entreprise" },
  { key: "logo_url", label: "URL du logo" },
  { key: "address", label: "Adresse" },
  { key: "whatsapp", label: "Numéro WhatsApp" },
  { key: "facebook", label: "Facebook" },
  { key: "instagram", label: "Instagram" },
  { key: "currency", label: "Devise (ex: KMF, EUR)" },
  { key: "opening_hours", label: "Horaires d'ouverture" },
];

export default function SettingsPage() {
  const { loadSettings } = useAuth();
  const [form, setForm] = useState({});

  useEffect(() => { api.get("/settings").then((r) => setForm(r.data || {})); }, []);

  const save = async () => {
    try {
      await api.put("/settings", form);
      toast.success("Réglages enregistrés");
      loadSettings();
    } catch (e) { toast.error(apiError(e)); }
  };

  const testReport = async () => {
    try {
      const r = await api.post("/cash-closings/send-daily-report");
      if (r.data.sent) toast.success(`Récap envoyé à ${r.data.email}`);
      else toast.error("Échec de l'envoi — vérifiez le domaine vérifié dans Resend");
    } catch (e) { toast.error(apiError(e)); }
  };

  return (
    <div className="space-y-5 max-w-2xl">
      <h1 className="text-2xl font-bold text-slate-800">Réglages de l'entreprise</h1>
      <Card className="p-5 space-y-4">
        {FIELDS.map((f) => (
          <div key={f.key}>
            <Label>{f.label}</Label>
            <Input data-testid={`settings-${f.key}`} value={form[f.key] || ""} onChange={(e) => setForm({ ...form, [f.key]: e.target.value })} />
          </div>
        ))}
        <div>
          <Label>Texte de pied de reçu</Label>
          <Textarea data-testid="settings-receipt_footer" value={form.receipt_footer || ""} onChange={(e) => setForm({ ...form, receipt_footer: e.target.value })} />
        </div>

        <div className="border-t border-slate-100 pt-4 space-y-3">
          <h3 className="font-semibold text-slate-800">📊 Récap automatique de fin de journée</h3>
          <p className="text-sm text-slate-500">Chaque soir à 20h00, le récap complet de la caisse est envoyé automatiquement par email au gérant.</p>
          <label className="flex items-center gap-2 text-sm">
            <input type="checkbox" data-testid="settings-daily_report_enabled" checked={form.daily_report_enabled !== false} onChange={(e) => setForm({ ...form, daily_report_enabled: e.target.checked })} className="h-4 w-4 rounded border-slate-300" />
            Activer l'envoi automatique du soir
          </label>
          <div>
            <Label>Email de réception du récap</Label>
            <Input data-testid="settings-daily_report_email" type="email" value={form.daily_report_email || ""} onChange={(e) => setForm({ ...form, daily_report_email: e.target.value })} placeholder="gerant@exemple.com" />
          </div>
          <Button variant="outline" size="sm" data-testid="test-report-btn" onClick={testReport}>Envoyer un test maintenant</Button>
        </div>

        {form.logo_url && <img src={form.logo_url} alt="logo" className="h-16 rounded border border-slate-200 object-contain" />}
        <Button data-testid="save-settings-btn" onClick={save} className="bg-sky-600 hover:bg-sky-700">Enregistrer</Button>
      </Card>
    </div>
  );
}
